import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
const TopRightPrevArrow = ({ onClick, isDisabled, color = "white" })=>/*#__PURE__*/ _jsx("button", {
        type: "button",
        className: "carousel-arrow-wrapper prev",
        onClick: onClick,
        tabIndex: 0,
        disabled: isDisabled,
        style: {
            background: "transparent",
            border: "none",
            boxShadow: "none",
            padding: 0
        },
        children: /*#__PURE__*/ _jsxs("svg", {
            width: "62",
            height: "62",
            viewBox: "0 0 62 62",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ _jsx("circle", {
                    cx: "31",
                    cy: "31",
                    r: "30.5",
                    fill: "transparent",
                    stroke: color
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M18.2929 30.2929C17.9024 30.6834 17.9024 31.3166 18.2929 31.7071L24.6569 38.0711C25.0474 38.4616 25.6805 38.4616 26.0711 38.0711C26.4616 37.6805 26.4616 37.0474 26.0711 36.6569L20.4142 31L26.0711 25.3431C26.4616 24.9526 26.4616 24.3195 26.0711 23.9289C25.6805 23.5384 25.0474 23.5384 24.6569 23.9289L18.2929 30.2929ZM43 30L19 30V32H43V30Z",
                    fill: color
                })
            ]
        })
    });
export default TopRightPrevArrow;
